export default "__VITE_ASSET__bc544c02__"